import type { ProjectArtifact } from '@/api/project-artifacts.types';

/**
 * BRD detection is the artifact type discriminator only.
 * Create returns ~19 keys and GET ~20 (the extra is `statusGroup`).
 * Presence of `statusGroup` must never be treated as a BRD signal.
 */
export function isBrdArtifact(
  artifact: Pick<ProjectArtifact, 'type'> | null | undefined,
): boolean {
  return artifact?.type === 'brd';
}
